import { useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../common2/Breadcrumbs"
import { Box, Button, Grid, Typography,Radio,RadioGroup,FormControlLabel,CircularProgress} from "@mui/material"
import CommonStyles from "../../common/CommonStyles"
import CustomFormLabel from "../../common/form-label/CustomFormLabel "
import CustomInput from "../../common/textField/CustomInput"
import { useEffect, useState } from "react"
import CancelIcon from "@mui/icons-material/Cancel";
import { useDispatch } from "react-redux"
import { addSSOConfig, editSSOConfig, getSSOConfigByID } from "../../../redux/actions/adminInterfaces/SSOConfig"

export default function AddSSOConfig() {

    const param = useParams()
    const navigate = useNavigate()
    const classes = CommonStyles()
    const dispatch = useDispatch()
    const [isSubmit,setIsSubmit] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState({
        type:"Microsoft",
        name: "",
        clientId: "",
        tenantId: "",
        clientSecret:"",
        isActive:true
    })
    const onchangeHandler = (e: any) => {
        const val = e.target.value;
        const name = e.target.name;
        //;
        setData((data:any) => ({
            ...data,
            [name]: val,
        }));
    };
    console.log(data);
    const submitForm = () => {
         if (isSaving) return;
         setIsSubmit(true); 
         if (!data.type || !data.name || !data.clientId || !data.tenantId || !data.clientSecret) {
             return; 
            }
            setIsSaving(true);
            console.log("dataaaaa",data)
        // if (isSaving) return;
        if (param.id) {
            console.log("its Update", data);
            dispatch(editSSOConfig(param.id, data, backHandler))
        } else {
            dispatch(addSSOConfig(data, backHandler))
        }
    }
    const getSSOConfigByIDCB = (val: any) => {
        setData({ ...val })
    }
    useEffect(() => {
        if (param?.id)
            dispatch(getSSOConfigByID(param.id, getSSOConfigByIDCB));
    }, [])
    const backHandler = () => {
        setIsSaving(false);
        navigate('/SSOConfig')
    }

    return (
        <>
            <Breadcrumbs
                data={[
                    {
                        title: 'Interfaces',
                        path: '/adminPanel'
                    },
                    {
                        title: 'SSO Config',
                        path: '/SSOConfig'
                    },
                    {
                        title: `${param.id ? "Edit" : "Add"}-SSO Config`,
                        path: `${param.id ? `/AddSSOConfig/${param.id}` : '/AddSSOConfig'}`,
                    }
                ]
                }
            />
            <br />
            <Box className={`pageHolder ${classes.px1}`}>
                <Box>
                    <Box className="mb2 pb2">
                        <Typography variant="h6" className={`${classes.themeColorTxt}`}>
                            {param.id ? 'Edit SSO Config' : "Add SSO Config"}
                        </Typography>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item md={4} xs={12} className="Add-SSO-Config">
                             <RadioGroup row value={data.type} onChange={onchangeHandler} name="type">
                                <FormControlLabel value="Microsoft" control={<Radio />} label="Microsoft" />
                                <FormControlLabel value="Google" control={<Radio />} label="Google" />
                            </RadioGroup>
                            <CustomFormLabel
                                classNames={`${classes.themeColorTxt}`}
                                labelName={"Name"}
                                isMandotary={true}
                            />
                            <CustomInput
                                isDisabled={false}
                                readOnly={false}
                                onClick={null}
                                iconPosition={"start"}
                                icon={false}
                                isError={isSubmit && !data.name}
                                name="name"
                                value={data.name}
                                label={"Enter the name"}
                                onChange={onchangeHandler}
                                helperText={isSubmit && !data.name ? "Enter Name":""}
                                placeholder={"Please Enter"}
                            />{" "}

                            <CustomFormLabel
                                classNames={`${classes.themeColorTxt}`}
                                labelName={"Client ID"}
                                isMandotary={true}
                            />
                            <CustomInput
                                isDisabled={false}
                                readOnly={false}
                                onClick={null}
                                iconPosition={"start"}
                                icon={false}
                                isError={isSubmit && !data.clientId}
                                name="clientId"
                                value={data.clientId}
                                label={"Enter the clientId"}
                                onChange={onchangeHandler}
                                helperText={isSubmit && !data.clientId ? "Enter Client ID":""}
                                placeholder={"Please Enter"}
                            />{" "}
                            <CustomFormLabel
                                classNames={`${classes.themeColorTxt}`}
                                labelName={"Tenant ID"}
                                isMandotary={true}
                            />
                            <CustomInput
                                isDisabled={false}
                                readOnly={false}
                                onClick={null}
                                iconPosition={"start"}
                                icon={false}
                                isError={isSubmit && !data.tenantId}
                                name="tenantId"
                                value={data.tenantId}
                                label={"Enter the tenantId"}
                                onChange={onchangeHandler}
                                helperText={isSubmit && !data.tenantId ? "Enter Tenant ID" : ""}
                                placeholder={"Please Enter"}
                            />{" "}
                            <CustomFormLabel
                                classNames={`${classes.themeColorTxt}`}
                                labelName={"Client Secret"}
                                isMandotary={true}
                            />
                            <CustomInput
                                isDisabled={false}
                                readOnly={false}
                                onClick={null}
                                iconPosition={"start"}
                                icon={false}
                                isError={isSubmit && !data.clientSecret}
                                name="clientSecret"
                                value={data.clientSecret}
                                label={"Enter the Client Secret"}
                                onChange={onchangeHandler}
                                helperText={isSubmit && !data.clientSecret ? "Enter Client Secret" : ""}
                                type="password"
                                placeholder={"Please Enter"}
                            />{" "}
                            <Box className="text-center">
                                <Button
                                    className={`${classes.btn} ${classes.btnCancel}`}
                                    variant="outlined"
                                    onClick={backHandler}
                                >
                                    <CancelIcon style={{ marginRight: "5px" }} />
                                    Cancel

                                </Button>
                                <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <Button
                                    className={`${classes.btn} ${classes.btnSubmit}`}
                                    variant="contained"
                                    disabled={isSaving}
                                    startIcon={
                                        isSaving ? <CircularProgress size={18} color="inherit" /> : ""
                                    }
                                    onClick={submitForm}
                                >
                                    {isSaving 
                                        ? (param?.id ? "Updating..." : "Saving...") 
                                        : (!param?.id ? "Save" : "Update")}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </>
    )
}